module.exports = __webpack_public_path__ + "static/assets/837d221121f5f6dc06f1ae42a7f5e071.svg";